import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link, useParams } from 'react-router-dom';
import DisplayMeasurementDetail from './DisplayMeasurementDetail';

type RouteMeasurementDetailParams = {
  measurementID: string;
}

const RouteMeasurementDetail = () => {
  let { measurementID } = useParams<keyof RouteMeasurementDetailParams>() as RouteMeasurementDetailParams;
  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to={`/measurement/${measurementID}/edit`}>
            <Button>Edit</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <DisplayMeasurementDetail measurementID={measurementID} />
        </Col>
      </Row>
    </>
  );
};

export default RouteMeasurementDetail;
